import { gql } from '@apollo/client';

export const SCHEDULE_FRAGMENT = gql`
  fragment ScheduleFragment on schedule {
    id
    date
    attendance {
      player {
        firstName
        lastName
      }
      playerId
      teamId
    }
    away
    awayGoalie
    awayScore
    awayShots
    awayTeam {
      name
      abbreviation
      id
      color
      colorSecondary
    }
    cancel
    eng: goals(where: { en: { _eq: true } }) {
      teamId
    }
    home
    homeGoalie
    homeScore
    homeShots
    homeTeam {
      name
      abbreviation
      id
      color
      colorSecondary
    }
    goals {
      goal
      en
      primaryAssist
      secondaryAssist
      teamId
    }
    note
    penalties {
      minutes
      playerId
    }
    pickup
    ot
    rinkLocation {
      address
      city
      name
      id
      website
    }
    playoffs
    season {
      season
      year
    }
    seasonId
    time
  }
`;
